import { RightClickMenu } from './right-click-menu'

export * from './right-click-menu'
export * from './right-click-menu-plugin'

export default RightClickMenu